import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Hub, TimerStickerValue} from 'yougile-model'
import {useMainMenuStore} from '@components/main-menu/main-menu-store'
import {Menu} from '@components/menu'
import {byTimeGlobalStore} from '@components/statistics/by-time/by-time-global-store'
import {StopwatchColumnContentBase} from '@components/sticker/my-stickers/board-stickers/sticker-settings/stopwatch/stopwatch-column-content'
import {PageService} from '@extensions/page-service'

interface Props {
  task: Hub
  close: () => void
  timerValue: TimerStickerValue
}

export const TaskTimelinePopup = (props: Props) => {
  const [menuState] = useMainMenuStore()
  const {close, task, timerValue} = props

  const goToReport = () => {
    byTimeGlobalStore.onSelectProject(PageService.getCurrentProject().id)
    byTimeGlobalStore.onSelectBoard(PageService.getCurrentBoard().id)
    PageService.goToStatistics('by-time')
  }

  return (
    <Menu
      className="sticker-item-list filter"
      onDragEnter={close}
      onEscape={close}
    >
      <div className="sticker-item-list__overlay" onClick={close} />
      <div className="sticker-item-list__wnd">
        <div className="sticker-item-list-head flex">
          {Lang.msg.board.timeInColumn}
          {menuState.canSeeStatsPage && (
            <span className="_link sticker-item-unpin" onClick={goToReport}>
              {Lang.msg.board.fullReport}
            </span>
          )}
        </div>
        <div className="sticker-item-list-body">
          <div className="sticker-timer-edit">
            <div className="sticker-timer-edit-tl border-b-0">
              <StopwatchColumnContentBase
                timerStickerValue={timerValue}
                task={task}
                title={Lang.msg.board.timeSpentInColumn}
              />
            </div>
          </div>
        </div>
      </div>
    </Menu>
  )
}
